import React, { useState } from 'react';

function Footer() {
  return (
    <div className={"text-center bg-gray-100 py-3 mt-10 px-4"}>
          Powered by Netlify, ReactJS, Tailwind CSS &amp; Firestore
    </div>
  )
}

export default Footer;